import event from "./event.component";
import eventUrls from "./event.urls";
import EventTransforms from "./event.transforms";

const eventModule = angular
  .module("app.components.event", [])
  .component("eventPage", event)
  .service("EventTransforms", EventTransforms)
  .config(eventUrls);

export default eventModule;



// WEBPACK FOOTER //
// ./src/pages/event/event.module.js